import { FC, useCallback } from 'react'
import { useScreenBreakpoint } from '../hooks/toolkit'
import { useUserAgamiList } from '../hooks/useUserAgamiList'
import { AddAgamiToExperienceDialog } from './AddAgamiToExperienceDialog'
import { AddAgamiToExperienceSheet } from './AddAgamiToExperienceSheet'

interface AddAgamiToExperienceProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  currentExpId: string
  refetchAgamiList: () => Promise<void>
}

export const AddAgamiToExperience: FC<AddAgamiToExperienceProps> = ({
  isOpen,
  setIsOpen,
  currentExpId,
  refetchAgamiList,
}) => {
  const { isLoading, agamiList, refetch } = useUserAgamiList({
    getExpRelations: true,
    getAudioUrls: false,
    enabled: isOpen,
  })

  const refetchAfterChange = useCallback(async () => {
    await refetchAgamiList()
    await refetch()
  }, [refetchAgamiList, refetch])

  const screenBreakpoint = useScreenBreakpoint()

  return (
    <>
      {screenBreakpoint === 'sm' ? (
        <AddAgamiToExperienceSheet
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          currentExpId={currentExpId}
          isLoading={isLoading}
          agamiList={agamiList}
          refetchAfterChange={refetchAfterChange}
        />
      ) : (
        <AddAgamiToExperienceDialog
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          currentExpId={currentExpId}
          isLoading={isLoading}
          agamiList={agamiList}
          refetchAfterChange={refetchAfterChange}
        />
      )}
    </>
  )
}
